// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WebDesignRouteImport } from './routes/web-design'
import { Route as ValueForMoneyGarageEastLondonRouteImport } from './routes/value-for-money-garage-east-london'
import { Route as UberMotEastLondonRouteImport } from './routes/uber-mot-east-london'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SymptomCheckerRouteImport } from './routes/symptom-checker'
import { Route as ServicingRouteImport } from './routes/servicing'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as ReviewsRouteImport } from './routes/reviews'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PremiumGalleryRouteImport } from './routes/premium-gallery'
import { Route as PcoMotEastLondonRouteImport } from './routes/pco-mot-east-london'
import { Route as OfficialBusinessInformationRouteImport } from './routes/official-business-information'
import { Route as MotoristHelpRouteImport } from './routes/motorist-help'
import { Route as MotChecklistBeforeTestRouteImport } from './routes/mot-checklist-before-test'
import { Route as MotChecklistRouteImport } from './routes/mot-checklist'
import { Route as MotRouteImport } from './routes/mot'
import { Route as MechanicalRepairsRouteImport } from './routes/mechanical-repairs'
import { Route as ManagedByRouteImport } from './routes/managed-by'
import { Route as GoogleMapsGarageE14RouteImport } from './routes/google-maps-garage-e14'
import { Route as GarageNearMeRouteImport } from './routes/garage-near-me'
import { Route as GarageForUberBoltDriversEastLondonRouteImport } from './routes/garage-for-uber-bolt-drivers-east-london'
import { Route as GalleryRouteImport } from './routes/gallery'
import { Route as FreeCarResourcesRouteImport } from './routes/free-car-resources'
import { Route as DieselDpfEgrEastLondonRouteImport } from './routes/diesel-dpf-egr-east-london'
import { Route as DiagnosticsRouteImport } from './routes/diagnostics'
import { Route as CostRouteImport } from './routes/cost'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as BookRouteImport } from './routes/book'
import { Route as BodyworkRouteImport } from './routes/bodywork'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as AreasRouteImport } from './routes/areas'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ResourcesUsedCarViewingChecklistRouteImport } from './routes/resources.used-car-viewing-checklist'
import { Route as ResourcesPcoDriverVehicleChecklistRouteImport } from './routes/resources.pco-driver-vehicle-checklist'
import { Route as ResourcesMotPassChecklistRouteImport } from './routes/resources.mot-pass-checklist'
import { Route as ResourcesDashboardWarningLightGuideRouteImport } from './routes/resources.dashboard-warning-light-guide'
import { Route as PoplarTyresRouteImport } from './routes/poplar.tyres'
import { Route as PoplarSuspensionRepairsRouteImport } from './routes/poplar.suspension-repairs'
import { Route as PoplarClutchRepairsRouteImport } from './routes/poplar.clutch-repairs'
import { Route as PoplarBrakesRouteImport } from './routes/poplar.brakes'
import { Route as PSplatRouteImport } from './routes/p.$'
import { Route as GuideClass7MotRouteImport } from './routes/guide.class-7-mot'
import { Route as GuideSlugRouteImport } from './routes/guide.$slug'
import { Route as CanaryWharfBrakesRouteImport } from './routes/canary-wharf.brakes'
import { Route as ServicesEvHybridServicingRouteImport } from './routes/services.ev-hybrid-servicing'
import { Route as ServicesAirConRegasRouteImport } from './routes/services.air-con-regas'
import { Route as CostIndexRouteImport } from './routes/cost.index'
import { Route as CostSlugRouteImport } from './routes/cost.$slug'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as AreasAreaRouteImport } from './routes/areas.$area'
import { Route as AdminSplatRouteImport } from './routes/admin.$'
import { Route as AreasLocalAreaRouteImport } from './routes/areas.local.$area'
import { Route as AreasAreaServiceRouteImport } from './routes/areas.$area.$service'

const WebDesignRoute = WebDesignRouteImport.update({
            id: '/web-design',path: '/web-design',getParentRoute: () => rootRouteImport
          })
const ValueForMoneyGarageEastLondonRoute = ValueForMoneyGarageEastLondonRouteImport.update({
            id: '/value-for-money-garage-east-london',path: '/value-for-money-garage-east-london',getParentRoute: () => rootRouteImport
          })
const UberMotEastLondonRoute = UberMotEastLondonRouteImport.update({
            id: '/uber-mot-east-london',path: '/uber-mot-east-london',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SymptomCheckerRoute = SymptomCheckerRouteImport.update({
            id: '/symptom-checker',path: '/symptom-checker',getParentRoute: () => rootRouteImport
          })
const ServicingRoute = ServicingRouteImport.update({
            id: '/servicing',path: '/servicing',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const ReviewsRoute = ReviewsRouteImport.update({
            id: '/reviews',path: '/reviews',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PremiumGalleryRoute = PremiumGalleryRouteImport.update({
            id: '/premium-gallery',path: '/premium-gallery',getParentRoute: () => rootRouteImport
          })
const PcoMotEastLondonRoute = PcoMotEastLondonRouteImport.update({
            id: '/pco-mot-east-london',path: '/pco-mot-east-london',getParentRoute: () => rootRouteImport
          })
const OfficialBusinessInformationRoute = OfficialBusinessInformationRouteImport.update({
            id: '/official-business-information',path: '/official-business-information',getParentRoute: () => rootRouteImport
          })
const MotoristHelpRoute = MotoristHelpRouteImport.update({
            id: '/motorist-help',path: '/motorist-help',getParentRoute: () => rootRouteImport
          })
const MotChecklistBeforeTestRoute = MotChecklistBeforeTestRouteImport.update({
            id: '/mot-checklist-before-test',path: '/mot-checklist-before-test',getParentRoute: () => rootRouteImport
          })
const MotChecklistRoute = MotChecklistRouteImport.update({
            id: '/mot-checklist',path: '/mot-checklist',getParentRoute: () => rootRouteImport
          })
const MotRoute = MotRouteImport.update({
            id: '/mot',path: '/mot',getParentRoute: () => rootRouteImport
          })
const MechanicalRepairsRoute = MechanicalRepairsRouteImport.update({
            id: '/mechanical-repairs',path: '/mechanical-repairs',getParentRoute: () => rootRouteImport
          })
const ManagedByRoute = ManagedByRouteImport.update({
            id: '/managed-by',path: '/managed-by',getParentRoute: () => rootRouteImport
          })
const GoogleMapsGarageE14Route = GoogleMapsGarageE14RouteImport.update({
            id: '/google-maps-garage-e14',path: '/google-maps-garage-e14',getParentRoute: () => rootRouteImport
          })
const GarageNearMeRoute = GarageNearMeRouteImport.update({
            id: '/garage-near-me',path: '/garage-near-me',getParentRoute: () => rootRouteImport
          })
const GarageForUberBoltDriversEastLondonRoute = GarageForUberBoltDriversEastLondonRouteImport.update({
            id: '/garage-for-uber-bolt-drivers-east-london',path: '/garage-for-uber-bolt-drivers-east-london',getParentRoute: () => rootRouteImport
          })
const GalleryRoute = GalleryRouteImport.update({
            id: '/gallery',path: '/gallery',getParentRoute: () => rootRouteImport
          })
const FreeCarResourcesRoute = FreeCarResourcesRouteImport.update({
            id: '/free-car-resources',path: '/free-car-resources',getParentRoute: () => rootRouteImport
          })
const DieselDpfEgrEastLondonRoute = DieselDpfEgrEastLondonRouteImport.update({
            id: '/diesel-dpf-egr-east-london',path: '/diesel-dpf-egr-east-london',getParentRoute: () => rootRouteImport
          })
const DiagnosticsRoute = DiagnosticsRouteImport.update({
            id: '/diagnostics',path: '/diagnostics',getParentRoute: () => rootRouteImport
          })
const CostRoute = CostRouteImport.update({
            id: '/cost',path: '/cost',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const BookRoute = BookRouteImport.update({
            id: '/book',path: '/book',getParentRoute: () => rootRouteImport
          })
const BodyworkRoute = BodyworkRouteImport.update({
            id: '/bodywork',path: '/bodywork',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const AreasRoute = AreasRouteImport.update({
            id: '/areas',path: '/areas',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ResourcesUsedCarViewingChecklistRoute = ResourcesUsedCarViewingChecklistRouteImport.update({
            id: '/resources/used-car-viewing-checklist',path: '/resources/used-car-viewing-checklist',getParentRoute: () => rootRouteImport
          })
const ResourcesPcoDriverVehicleChecklistRoute = ResourcesPcoDriverVehicleChecklistRouteImport.update({
            id: '/resources/pco-driver-vehicle-checklist',path: '/resources/pco-driver-vehicle-checklist',getParentRoute: () => rootRouteImport
          })
const ResourcesMotPassChecklistRoute = ResourcesMotPassChecklistRouteImport.update({
            id: '/resources/mot-pass-checklist',path: '/resources/mot-pass-checklist',getParentRoute: () => rootRouteImport
          })
const ResourcesDashboardWarningLightGuideRoute = ResourcesDashboardWarningLightGuideRouteImport.update({
            id: '/resources/dashboard-warning-light-guide',path: '/resources/dashboard-warning-light-guide',getParentRoute: () => rootRouteImport
          })
const PoplarTyresRoute = PoplarTyresRouteImport.update({
            id: '/poplar/tyres',path: '/poplar/tyres',getParentRoute: () => rootRouteImport
          })
const PoplarSuspensionRepairsRoute = PoplarSuspensionRepairsRouteImport.update({
            id: '/poplar/suspension-repairs',path: '/poplar/suspension-repairs',getParentRoute: () => rootRouteImport
          })
const PoplarClutchRepairsRoute = PoplarClutchRepairsRouteImport.update({
            id: '/poplar/clutch-repairs',path: '/poplar/clutch-repairs',getParentRoute: () => rootRouteImport
          })
const PoplarBrakesRoute = PoplarBrakesRouteImport.update({
            id: '/poplar/brakes',path: '/poplar/brakes',getParentRoute: () => rootRouteImport
          })
const PSplatRoute = PSplatRouteImport.update({
            id: '/p/$',path: '/p/$',getParentRoute: () => rootRouteImport
          })
const GuideClass7MotRoute = GuideClass7MotRouteImport.update({
            id: '/guide/class-7-mot',path: '/guide/class-7-mot',getParentRoute: () => rootRouteImport
          })
const GuideSlugRoute = GuideSlugRouteImport.update({
            id: '/guide/$slug',path: '/guide/$slug',getParentRoute: () => rootRouteImport
          })
const CanaryWharfBrakesRoute = CanaryWharfBrakesRouteImport.update({
            id: '/canary-wharf/brakes',path: '/canary-wharf/brakes',getParentRoute: () => rootRouteImport
          })
const ServicesEvHybridServicingRoute = ServicesEvHybridServicingRouteImport.update({
            id: '/ev-hybrid-servicing',path: '/ev-hybrid-servicing',getParentRoute: () => ServicesRoute
          })
const ServicesAirConRegasRoute = ServicesAirConRegasRouteImport.update({
            id: '/air-con-regas',path: '/air-con-regas',getParentRoute: () => ServicesRoute
          })
const CostIndexRoute = CostIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CostRoute
          })
const CostSlugRoute = CostSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => CostRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })
const AreasAreaRoute = AreasAreaRouteImport.update({
            id: '/$area',path: '/$area',getParentRoute: () => AreasRoute
          })
const AdminSplatRoute = AdminSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => AdminRoute
          })
const AreasLocalAreaRoute = AreasLocalAreaRouteImport.update({
            id: '/local/$area',path: '/local/$area',getParentRoute: () => AreasRoute
          })
const AreasAreaServiceRoute = AreasAreaServiceRouteImport.update({
            id: '/$service',path: '/$service',getParentRoute: () => AreasAreaRoute
          })





const AdminRouteChildren = {
  AdminSplatRoute: AdminSplatRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const AreasAreaRouteChildren = {
  AreasAreaServiceRoute: AreasAreaServiceRoute
}

const AreasAreaRouteWithChildren = AreasAreaRoute._addFileChildren(AreasAreaRouteChildren)



const AreasRouteChildren = {
  AreasAreaRoute: AreasAreaRouteWithChildren,AreasLocalAreaRoute: AreasLocalAreaRoute
}

const AreasRouteWithChildren = AreasRoute._addFileChildren(AreasRouteChildren)




const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)




const CostRouteChildren = {
  CostSlugRoute: CostSlugRoute,CostIndexRoute: CostIndexRoute
}

const CostRouteWithChildren = CostRoute._addFileChildren(CostRouteChildren)




const ServicesRouteChildren = {
  ServicesAirConRegasRoute: ServicesAirConRegasRoute,ServicesEvHybridServicingRoute: ServicesEvHybridServicingRoute
}

const ServicesRouteWithChildren = ServicesRoute._addFileChildren(ServicesRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AdminRoute: AdminRouteWithChildren,AreasRoute: AreasRouteWithChildren,BlogRoute: BlogRouteWithChildren,BodyworkRoute: BodyworkRoute,BookRoute: BookRoute,ContactRoute: ContactRoute,CookiesRoute: CookiesRoute,CostRoute: CostRouteWithChildren,DiagnosticsRoute: DiagnosticsRoute,DieselDpfEgrEastLondonRoute: DieselDpfEgrEastLondonRoute,FreeCarResourcesRoute: FreeCarResourcesRoute,GalleryRoute: GalleryRoute,GarageForUberBoltDriversEastLondonRoute: GarageForUberBoltDriversEastLondonRoute,GarageNearMeRoute: GarageNearMeRoute,GoogleMapsGarageE14Route: GoogleMapsGarageE14Route,ManagedByRoute: ManagedByRoute,MechanicalRepairsRoute: MechanicalRepairsRoute,MotRoute: MotRoute,MotChecklistRoute: MotChecklistRoute,MotChecklistBeforeTestRoute: MotChecklistBeforeTestRoute,MotoristHelpRoute: MotoristHelpRoute,OfficialBusinessInformationRoute: OfficialBusinessInformationRoute,PcoMotEastLondonRoute: PcoMotEastLondonRoute,PremiumGalleryRoute: PremiumGalleryRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,ReviewsRoute: ReviewsRoute,ServicesRoute: ServicesRouteWithChildren,ServicingRoute: ServicingRoute,SymptomCheckerRoute: SymptomCheckerRoute,TermsRoute: TermsRoute,UberMotEastLondonRoute: UberMotEastLondonRoute,ValueForMoneyGarageEastLondonRoute: ValueForMoneyGarageEastLondonRoute,WebDesignRoute: WebDesignRoute,CanaryWharfBrakesRoute: CanaryWharfBrakesRoute,GuideSlugRoute: GuideSlugRoute,GuideClass7MotRoute: GuideClass7MotRoute,PSplatRoute: PSplatRoute,PoplarBrakesRoute: PoplarBrakesRoute,PoplarClutchRepairsRoute: PoplarClutchRepairsRoute,PoplarSuspensionRepairsRoute: PoplarSuspensionRepairsRoute,PoplarTyresRoute: PoplarTyresRoute,ResourcesDashboardWarningLightGuideRoute: ResourcesDashboardWarningLightGuideRoute,ResourcesMotPassChecklistRoute: ResourcesMotPassChecklistRoute,ResourcesPcoDriverVehicleChecklistRoute: ResourcesPcoDriverVehicleChecklistRoute,ResourcesUsedCarViewingChecklistRoute: ResourcesUsedCarViewingChecklistRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)